import { renderColor } from './colors';
import React from 'react';
import { Popover } from '@mui/material';
import { canReadTags } from 'store/tags/tag.utils';

export const TagBox = ({ tags, noTool, count, wrapperStyles = {} }) => {
    const tagCount = count ? count : 3;
    const list = noTool ? tags : tags?.length > tagCount ? tags.slice(0, tagCount) : tags;
    const croppedList = noTool ? null : tags?.length > tagCount ? tags.slice(tagCount) : null;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    // Read-only chips, but still tag data: hide them from a user holding neither TAG_READ nor
    // TAG_MANAGE. Placed after the hooks above so hook order stays stable across permission states.
    if (!tags?.length || !canReadTags()) {
        return null;
    }

    return (
        <div className="tags-box-wrapper" style={{ ...wrapperStyles }}>
            {list?.map((tag, index) => (
                <div
                    style={{
                        background: renderColor(tag?.color).background,
                        color: renderColor(tag?.color).color,
                    }}
                    key={index}
                    className="tag-box"
                >
                    {tag?.name}
                </div>
            ))}

            {croppedList && (
                <button
                    aria-owns={open ? 'mouse-over-popover' : undefined}
                    aria-haspopup="true"
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={handlePopoverClose}
                    className="tag-count"
                >
                    +{tags.length - tagCount}
                </button>
            )}

            <Popover
                id="mouse-over-popover"
                // Portaled to <body>: must sit above MUI Modal (1300) so the hover list shows inside modals too.
                sx={{
                    pointerEvents: 'none',
                    zIndex: (theme) => theme.zIndex.modal + 1,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
            >
                <div className="tag-more-info-box">
                    {croppedList?.map((tag, index) => (
                        <div
                            style={{
                                background: renderColor(tag?.color).background,
                                color: renderColor(tag?.color).color,
                            }}
                            key={index}
                            className="tag-box"
                        >
                            {tag?.name}
                        </div>
                    ))}
                </div>
            </Popover>
        </div>
    );
};
